export default __webpack_public_path__ + "static/media/education-ki.8677c411.jpg";